export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';
export const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT';
export const CLEAR_ACCOUNTS = 'CLEAR_ACCOUNTS';
